// extracted by mini-css-extract-plugin
export default {"reasonsContainer":"SourceList_reasonsContainer__-sLmS","header":"SourceList_header__iASw1","noReasons":"SourceList_noReasons__3lTsf"};